// import { createStore, applyMiddleware } from "redux";
// import { thunk } from "redux-thunk";
// import reducer from "./fetchData"; // Make sure this imports a valid reducer function

// const configureStore = preloadedState => {
//   const store = createStore(
//     reducer,
//     preloadedState,
//     applyMiddleware(thunk)
//   );
//   console.log("actual store ::::",store)
//   return store;
// };
// export default configureStore;

import { createStore, applyMiddleware } from "redux";
import {thunk} from "redux-thunk";
import rootReducer from "./store/reducers/index";   // 👈 combined reducer

const configureStore = preloadedState => {
  const store = createStore(
    rootReducer,
    preloadedState,
    applyMiddleware(thunk)
  );

  console.log("ACTUAL STORE:", store.getState());
  return store;
};

export default configureStore;



